// extracted by mini-css-extract-plugin
export default {"Gspecifications":"Gspecifications_Gspecifications__F6S1Z"};